'use strict';

var _features = {};
module.exports = {
    init: function (features) {
        _features = features;
    },
    isEnabled: function (feature) {
        return !!_features[feature] && _features[feature] === true;
    },
};
